import { useSelector } from 'react-redux';
import { DeepLinkSearchParams } from '@server/deep-link-search-params';
import useQueryParams from '../../../../navigation-utils/useQueryParams';
import { useRunOnceWhenTruthy } from '../../../common/useRunOnceWhenTruthy';
import { buildConfigurationItemId } from '../../salesforce-documentation-card/helpers';
import {
  DocumentationCardContentViewType,
  DocumentationCardItem,
} from '../../salesforce-documentation-card/types';
import { selectDocumentationActiveObjectData } from '../../../../reducers/documentation/salesforceDocumentationReducer';
import { SalesforceItem } from '../../../parser/ConfigurationItemTypes';

export const useCardListHandleDeepLink = ({
  list,
  handleSetConfigurationItem,
}: {
  list: SalesforceItem[];
  handleSetConfigurationItem: (props: DocumentationCardItem) => void;
}) => {
  const queryParams = useQueryParams();
  const allElements = useSelector(selectDocumentationActiveObjectData);
  const areElementsLoaded = Boolean(allElements);

  useRunOnceWhenTruthy(() => {
    const configurationItemId = queryParams.get(DeepLinkSearchParams.configurationItemId);
    if (configurationItemId) {
      const item = list.find((item) => buildConfigurationItemId(item) === configurationItemId);
      if (item) {
        handleSetConfigurationItem({
          item,
          clearHistory: true,
          contentType: DocumentationCardContentViewType.default,
        });
      }
    }
  }, areElementsLoaded);
};
